module.exports = __webpack_public_path__ + "img/92129.4f7fa043.svg";